/*
 * @Author: 欧阳铭山
 * @Date: 2022-06-22 17:08:44
 * @Description: Description
 * @FilePath: \ys.gnss\src\main.js
 */
import './public-path';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'
import ElementUI from 'element-ui';
import * as echarts from "echarts"
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/base.scss'
import '@/assets/icons/svg'
//全局组件
import GL_Component from '@/utils/globalComponents'

Vue.use(GL_Component);
Vue.use(ElementUI,{size:'small'})
import uploader from 'vue-simple-uploader'
Vue.use(uploader);
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts

new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');